import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  mensagemDebitoAutomatico: 'Na data de vencimento, se você tiver saldo suficiente na conta do Mercado Pago, o valor total da parcela será debitado automaticamente. Isso garante que você mantenha seu acordo em dia de forma fácil e prática.',
  mensagemAcompanhamentoAplicativo: 'Todas as atualizações das negociações com o Mercado Livre/Mercado Pago devem ser acompanhadas exclusivamente pelo app. Nele, você encontrará informações detalhadas sobre o status dos seus pagamentos.',
  linkAplicativo: 'https://852u.adj.st/home/?adj_t=1cao6zgg&adj_fallback=https%3A%2F%2Fwww.mercadopago.com.br%2Fhub%2Fregistration%2Flanding%3Fredirect_url%3Dhttps%253A%252F%252Fwww.mercadopago.com.br%252Fconta&adj_redirect_macos=https%3A%2F%2Fwww.mercadopago.com.br%2Fhub%2Fregistration%2Flanding%3Fredirect_url%3Dhttps%253A%252F%252Fwww.mercadopago.com.br%252Fconta',
  nomeAplicativo: 'Mercado Pago',
  aplicativoMobile: true,
  mensagemTermoCondicoesGerais: 'Ao gerar o Parcelamento, você aceita os',
  mensagemUrlTermoCondicoesGerais: 'termos e condições do parcelamento de Dívida',
  showUltimaPropostaDescricao: () => false,
  showLogoTelaBoletos: () => true,
};

export default rules;
